export const appMail = {
    create: function () {
        var that = this, items = document.getElementsByClassName("absscr"), i = items.length;
        while (i--) {
            that.fresh(items[i]);
        }
    },
    fresh(item) {
        item.outerHTML = this.deco(item.getAttribute('data-str')).split("").reverse().join("");
    },
    deco(str) {
        var base64s = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
        var bits;
        var decOut = '';
        var i = 0;
        for (; i < str.length; i += 4) {
            bits = (base64s.indexOf(str.charAt(i)) & 0xff) << 18 |
                (base64s.indexOf(str.charAt(i + 1)) & 0xff) << 12 |
                (base64s.indexOf(str.charAt(i + 2)) & 0xff) << 6 |
                base64s.indexOf(str.charAt(i + 3)) & 0xff;
            decOut += String.fromCharCode((bits & 0xff0000) >> 16,
                (bits & 0xff00) >> 8, bits & 0xff);
        }
        if (str.charCodeAt(i - 2) == 61) {
            return (decOut.substring(0, decOut.length - 2));
        } else if (str.charCodeAt(i - 1) == 61) {
            return (decOut.substring(0, decOut.length - 1));
        } else {
            return (decOut)
        }
    },
};
